import { create } from 'zustand'
import AuthEventService from 'shared/services/authEventService'
import { KEY_MODIFICATION_WARNING_DISMISSED_KEY } from '../../constants/keyModification'

/** Initialize auth event subscription to clear dismissed state on login/logout */
let authSubscriptionInitialized = false

const initializeAuthSubscription = () => {
    if (authSubscriptionInitialized) return

    AuthEventService.subscribe((event) => {
        if (event === 'logout' || event === 'login') {
            try {
                sessionStorage.removeItem(KEY_MODIFICATION_WARNING_DISMISSED_KEY)
            } catch (error) {
                // Silent fallback - this is non-critical functionality
            }
        }
    })

    authSubscriptionInitialized = true
}

interface KeyModificationDialogState {
    isOpen: boolean
    isPTKey: boolean
    originalKey: string
    modifiedKey: string
    onProceed: (() => void) | null
    onCancel: (() => void) | null
    showDialog: (params: {
        isPTKey: boolean
        originalKey: string
        modifiedKey: string
        onProceed: () => void
        onCancel: () => void
    }) => void
    closeDialog: () => void
}

/**
 * Zustand store for managing the Key Modification Warning Dialog state
 */
export const useKeyModificationDialogStore = create<KeyModificationDialogState>(
    (set) => {
        // Initialize auth subscription on store creation
        initializeAuthSubscription()

        return {
            isOpen: false,
            isPTKey: false,
            originalKey: '',
            modifiedKey: '',
            onProceed: null,
            onCancel: null,
            showDialog: ({
                isPTKey,
                originalKey,
                modifiedKey,
                onProceed,
                onCancel,
            }) => {
                set({
                    isOpen: true,
                    isPTKey,
                    originalKey,
                    modifiedKey,
                    onProceed,
                    onCancel,
                })
            },
            closeDialog: () => {
                set({
                    isOpen: false,
                    isPTKey: false,
                    originalKey: '',
                    modifiedKey: '',
                    onProceed: null,
                    onCancel: null,
                })
            },
        }
    }
)
